import React from 'react';
import { css, cx } from '@emotion/css';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  error?: boolean;
}

const labelBase = css({
  display: 'inline-block',
  fontSize: 'var(--fs-400)',
  fontWeight: 500,
  color: 'var(--g-700)',
  marginBottom: 'var(--spacing-xs)',
  cursor: 'pointer',
});

const labelRequired = css({
  '&::after': {
    content: '" *"',
    color: 'var(--error-color, #e53e3e)',
    marginLeft: 'var(--spacing-3xs)',
  },
});

const labelError = css({
  color: 'var(--error-color, #e53e3e)',
});

export const Label: React.FC<LabelProps> = ({ 
  className, 
  required, 
  error,
  children,
  ...props 
}) => {
  return (
    <label
      className={cx(
        labelBase,
        required && labelRequired,
        error && labelError,
        className
      )}
      {...props}
    >
      {children}
    </label>
  );
};

export default Label;
